import MessageBox from 'components/global/chat/MessageBox'
import ParticipantAndDetails from './ParticipantAndDetails'
import SendInput from 'components/global/chat/SendInput'

const NotesTab = () => {
  return (
    <div className="flex gap-20px">
      <div className="flex-1 relative" style={{ minHeight: '35rem' }}>
        <div>
          <MessageBox
            recepient="receiver"
            messageType="text"
            messageText="Some note will go here, and it can be a mention of the user @username and the list of all tagged people goes below"
            name="Amin Mirza"
            time="10:10 AM"
            avatar=""
          />
        </div>
      </div>
      <div className="bg-dark-gray px-30px py-20px">
        <ParticipantAndDetails />
      </div>
    </div>
  )
}

export default NotesTab
